/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { WDHImage } from '@demant/wdh';
import { withReactBootstrap } from '@demant/wdh-react-bootstrap';

var BlogAuthorApp = function BlogAuthorApp(_ref) {
  var settings = _ref.settings;

  var getImage = function getImage() {
    var imageData = settings.authorImage;
    return /*#__PURE__*/React.createElement(WDHImage, {
      image: imageData.image
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "blog-author"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "blog-author-about"
  }, settings.authorAbout.text), /*#__PURE__*/React.createElement("div", {
    className: "blog-author-image"
  }, getImage()), /*#__PURE__*/React.createElement("div", {
    className: "blog-author-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-author-name"
  }, settings.authorName.text), /*#__PURE__*/React.createElement("div", {
    className: "blog-author-title"
  }, settings.authorTitle.text), /*#__PURE__*/React.createElement("div", {
    className: "blog-author-intro"
  }, settings.authorIntro.text), /*#__PURE__*/React.createElement("div", {
    className: "blog-author-link",
    dangerouslySetInnerHTML: {
      __html: settings.authorLink.html
    }
  }))));
};

export default withReactBootstrap(BlogAuthorApp);